import Field from "@components/inputs/field";
import Switch, { SwitchType } from "@components/inputs/switch/Switch";
import { SwitchWrapperStyled } from "@pages/fiscalYearClose/FiscalYearClose.styles";
import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { LabelStatus } from "../../enums";

interface IProps {
    isDisabled?: boolean;
    isChecked: boolean;
    onCheck: (checked: boolean) => Promise<void>;
}

const SectionSwitch: React.FC<IProps> = ({
                                             isDisabled,
                                             isChecked,
                                             onCheck
                                         }) => {
    const { t } = useTranslation("Components");
    const [isBusy, setIsBusy] = React.useState(false);

    const handleCheck = useCallback(async (checked: boolean) => {
        setIsBusy(true);
        await onCheck(checked);
        setIsBusy(false);
    }, [onCheck]);

    return (<SwitchWrapperStyled>
        <Field labelStatus={LabelStatus.Removed}
               isDisabled={isDisabled}
               name={"checkSectionSwitch"}>
            <Switch type={SwitchType.Icons}
                    hasSemanticColor={true}
                    checked={isChecked}
                    isDisabled={isDisabled}
                    isBusy={isBusy}
                    onChange={handleCheck}
                    label={t("Components:SplitWizard.Checked")}/>
        </Field>
    </SwitchWrapperStyled>);
};

export default SectionSwitch;
